/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useLayoutEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Link, useNavigate } from "react-router-dom";
import { errorState, evWhereMemberState, getEvWherePhoneState, loadingState, loginState, modalState, modalTypeState, userInfoState, userIntegratedState, variableState } from "../../recoil/atoms";
import { CheckBox, Div, Font, Input, Label, PageLayout } from "../../styles/commonStyle";
import { cardTitleColor, cardTitleColor2, fontGreyColor, orangeColor2, primaryColor } from "../../styles/theme";
import evWhereLogo from "../../assets/images/logo_evwhere.png";
import { EvWhereLogo, Flex, Line, LinkAccountSection, RoundButton, SubText, ToggleButton } from "./style";
import { ToggleButtonItem } from "./components/toggleButtonItem";
import { AppleButton, SocialKakao } from "../../components/socialButton/socialButton";
import TermsAgreement from "./components/termsAgreement";
import PhoneVerification from "./components/phoneVerification";
import EvWhereMemberLookup from "./components/evWhereMemberLookup";
import { Highlight, InfoContent, InfoItem, InfoList } from "./components/style";
import LinkAccountCompletePage from "./components/linkAccountCompletePage";
import { ResponseModel, RESULT } from "../../model/response";
import { User } from "../../model/user";
import useFetch from "../../hooks/useFetch";
import { showUserSelector, userIntegratedSelector } from "../../recoil/variableAtom";
import { getUserIdFromToken } from "../../util";
import usePost from "../../hooks/usePost";
import { IntegratedUser } from "../../model/userExists";
import Loading from "../../components/loading/loading";
import EvModal from "../../components/modal/evModal";

const TOGGLE_ON_BG = 'rgba(255, 129, 22, 0.1)';
const TOGGLE_ON_COLOR = '#ff8116';

function LinkAccountPage() {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useRecoilState(loadingState);
    const [isEvwhereMember, setIsEvwhereMember] = useState(true);
    const [isSearchCompleted, setIsSearchCompleted] = useState(false);
    const [isPhoneVerification, setIsPhoneVerification] = useState(false);
    const [isCert, setIsCert] = useState(false);
    const [isLinkAccountCompleted, setIsLinkAccountCompleted] = useState(false);
    const [userInfo, setUserInfo] = useRecoilState(userInfoState);
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [getEvWherePhone, setEvWherePhone] = useRecoilState(getEvWherePhoneState);
    const [userIntegrated, setUserIntegrated] = useRecoilState(userIntegratedState);
    const [islogin, setlogin] = useRecoilState(loginState);
    const [submitData, setSubmitData] = useState<IntegratedUser | undefined>(undefined);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [termsState, setTermsState] = useState({
        requiredChecked: false,
        optional: { 
            marketing: false, 
            email: false, 
            sms: false, 
            soc: false 
        },
        all: {
            terms: false,
            privacy: false,
            location: false,
            age: false,
            marketing: false,
            email: false,
            sms: false,
            soc: false,
        }
    });
    const userId = getUserIdFromToken();
    let accessToken = window.sessionStorage.getItem("accessToken");
    const responseUser: ResponseModel<User> = useFetch({
        recoilSelector: showUserSelector({ token: accessToken! }),
        query: userId,
    });

    useEffect(() => {
        setEvWherePhone(undefined);
    }, []);

    useEffect(() => {
        if (responseUser?.result === RESULT.OK) {
            setUserInfo(responseUser?.data);
        }
    }, [responseUser]);

    const handleCheckCert = () => {
        setIsCert(true);
    }

    const response: ResponseModel<any> = usePost({
        recoilSelector: userIntegratedSelector,
        data: submitData,
        recoilState: userIntegratedState,
    });
    const loginHandler = () => {
        setlogin(false);
        sessionStorage.clear();
    }

    const handleLinkAccount = () => {
        setLoading(true);
        if(isEvwhereMember && !isSearchCompleted) {
            alert('evWhere 회원 조회를 진행해주세요.');
            setLoading(false);
            return;
        }
        if (getEvWherePhone != userInfo?.phone) {
            if (!isCert) {
                alert('휴대폰 번호 인증을 진행해주세요.');
                setLoading(false);
                return;
            }
        }
        if (!termsState.requiredChecked) {
            alert('필수 약관에 동의해주세요.');
            setLoading(false);
            return;
        }
        var ssbypCode;
        switch (evWhereMember?.ssbyp) {
            case 'google':
                ssbypCode = '02';
                break;
            case 'kakao':
                ssbypCode = '03';
                break;
            case 'apple':
                ssbypCode = '04';
                break;
            default:
                ssbypCode = '01';
                break;
        }

        var data: IntegratedUser = {
            supplierCode: 'TD',
            ...(evWhereMember?.lgn_Id && { evwhereLgnId: evWhereMember?.lgn_Id }),
            ...(evWhereMember?.idToken && { token: evWhereMember?.idToken }),
            phone: userInfo?.phone,
            ...(evWhereMember?.ssbyp && { ssbyp: ssbypCode }),
            smsRcptnAgreYn: termsState.all.sms ? 'Y' : 'N',
            emlRcptnAgreYn: termsState.all.email ? 'Y' : 'N',
            smartControlPrivacyYn: termsState.all.soc ? 'Y' : 'N',
        }
        setSubmitData(data);
    }

    useEffect(() => {
        setLoading(false);
        if (response?.result === RESULT.OK) {
            setIsLinkAccountCompleted(true);
            loginHandler();
        }
        if(response?.result === RESULT.FAIL) {
            setModalOpen(true);
            setModalMessage(response?.msg ?? '');
        }
    }, [response]);

    useLayoutEffect(() => {
        setEvWhereMember(undefined);
    }, []);

    return (
        <>
            <PageLayout>
                {
                    isLinkAccountCompleted ? <LinkAccountCompletePage /> : <>
                        <Font fontSize="1.75rem" fontWeight="500" color={cardTitleColor2} changeFontSize="20px">
                            회원 통합하기
                        </Font>
                        <LinkAccountSection margin="30px 0 0 0">
                            <Flex gap="10px">
                                <EvWhereLogo src={evWhereLogo} alt="evWhereLogo" />
                                <Font fontSize="1.5rem" fontWeight="500" color={cardTitleColor2} changeFontSize="18px">
                                    회원이세요?
                                </Font>
                            </Flex>
                            {
                                isSearchCompleted ? (
                                    <>
                                        <SubText margin="12px 0 0 0">
                                            evWhere 회원 조회가 완료되었습니다. 아래 계정과 통합을 진행합니다.
                                        </SubText>
                                        <Flex changeFlexDirection="column" gap="10px" changeAlignItems="start" margin="24px 0 0 0" style={{ backgroundColor: "#f4f4f4", padding: '30px 40px' }}>
                                            evWhere 계정
                                            <Div style={{ backgroundColor: "#ffffff", padding: '8px 20px' }}>{evWhereMember?.lgn_Id ?? '-'}</Div>
                                        </Flex>
                                        {(getEvWherePhone != userInfo?.phone) ? (
                                            <>
                                                <PhoneVerification
                                                    type="COMMON"
                                                    hasLine={true}
                                                    phoneNumber={{
                                                        first: userInfo?.phone?.slice(0, 3) || '',
                                                        second: userInfo?.phone?.slice(3, 7) || '',
                                                        third: userInfo?.phone?.slice(7, 11) || ''
                                                    }}
                                                    title="휴대폰 번호 인증"
                                                    subText={
                                                        <div>
                                                            <div>조회하신 evWhere 계정과 evPlug 계정의 휴대폰 정보가 일치하지 않아 휴대폰 인증을 진행합니다.</div>
                                                            <div style={{ color: "#222222" }}>카카오톡으로 발송된 인증번호를 통해 인증된 휴대폰 번호가 통합 회원 정보로 등록됩니다.</div>
                                                        </div>
                                                    }
                                                    handleCheckCert={handleCheckCert}
                                                />
                                            </>
                                        ) : (
                                            <></>
                                        )
                                        }
                                    </>
                                ) : (
                                    <>
                                        <SubText margin="12px 0 0 0">
                                            evWhere 앱 회원이신 경우 계정 통합을 위해 아이디/비밀번호를 인증해주세요.
                                        </SubText>
                                        <Flex margin="20px 0 0 0">
                                            <ToggleButtonItem
                                                selected={isEvwhereMember}
                                                onClick={() => setIsEvwhereMember(true)}
                                                borderRadius="32px 0 0 32px"
                                            >
                                                evWhere 회원입니다
                                            </ToggleButtonItem>
                                            <ToggleButtonItem
                                                selected={!isEvwhereMember}
                                                onClick={() => setIsEvwhereMember(false)}
                                                borderRadius="0 32px 32px 0"
                                            >
                                                evWhere 회원이 아닙니다
                                            </ToggleButtonItem>
                                        </Flex>
                                        {
                                            isEvwhereMember ? (
                                                <EvWhereMemberLookup isSearchCompleted={isSearchCompleted} setIsSearchCompleted={setIsSearchCompleted} />
                                            ) : (
                                                <PhoneVerification
                                                    type="COMMON"
                                                    phoneNumber={{
                                                        first: userInfo?.phone?.slice(0, 3) || '',
                                                        second: userInfo?.phone?.slice(3, 7) || '',
                                                        third: userInfo?.phone?.slice(7, 11) || ''
                                                    }}
                                                    hasLine={true}
                                                    isEdit={false}
                                                    title="휴대폰 번호 인증"
                                                    subText={<div><div style={{ color: "#222222" }}>인증번호가 카카오톡으로 발송됩니다.</div><div style={{ fontSize: "14px", color: fontGreyColor }}>인증된 휴대폰 번호가 통합 회원 정보로 등록됩니다.</div></div>}
                                                    handleCheckCert={handleCheckCert}
                                                />
                                            )
                                        }
                                    </>
                                )
                            }

                        </LinkAccountSection>
                        <LinkAccountSection margin="45px 0">
                            <Font fontSize="1.5rem" fontWeight="500" color={cardTitleColor2} changeFontSize="18px">
                                회원통합 약관 동의
                            </Font>
                            <Div style={{ marginTop: "20px" }}>
                                <TermsAgreement onChange={setTermsState} />
                            </Div>
                        </LinkAccountSection>
                        <Flex justifyContent="center" style={{ maxWidth: "600px", marginBottom: "45px" }}>
                            <RoundButton changeFontSize="18px" onClick={handleLinkAccount} isDisabled={!termsState.requiredChecked} width="100%" fontSize="20px" height="60px" borderRadius="30px">회원 통합하기</RoundButton>
                        </Flex>
                    </>
                }

                <EvModal
                    open={modalOpen}
                    message={modalMessage}
                    onClose={() => {
                        setModalOpen(false);
                    }}
                />

            </PageLayout>
            <Loading isLoading={isLoading} />
        </>
    );
}

export default LinkAccountPage;
